export default {"src":"/_next/static/media/mobile.35587286.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};